import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function DeleteButton({ handler }) {
    const {
        t,
    } = useTranslation();

    return (
        <div className="float-right">
            <Button onClick={handler} variant="danger" size="md" className="text-danger btn-link edit" title={t("common.actions.delete")}>
                <i className="fa fa-times" />
            </Button>
        </div>
    );
}